var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modern-form"},[_c('v-container',[_c('PageTabs',{attrs:{"tabs":_vm.tabs}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }